export enum NodePurposeWire {
  root = 'root',
  today = 'today',
  inbox = 'inbox',
  virtual = 'virtual',
}
